import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CoreInjectorTokens, FbCoreModule } from '@fleet-beat/core';
import { EditorModule } from '@fleet-beat/editor';
import { AuthGuard, DataAutocompletePresetsModule } from '@fleet-beat/shared';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { httpInterceptorsProviders } from './http-interceptors/http-interceptors-providers';
import { SocketIoModule } from 'ngx-socket-io';

const socketConfig = {
  url: environment.messagingHubUrl,
  options: {
    transports: ['websocket'],
    auth: { token: localStorage.getItem('fb-token') },
  },
};
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FbCoreModule,
    RouterModule,
    AppRoutingModule,
    DataAutocompletePresetsModule,
    MatDialogModule,
    EditorModule,
    SocketIoModule.forRoot(socketConfig),
  ],
  providers: [
    { provide: CoreInjectorTokens.Environment, useValue: environment },
    { provide: CoreInjectorTokens.LoginUrl, useValue: '/auth/login' },
    ...httpInterceptorsProviders,
    AuthGuard,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
